<div class="info-sections-container">
  @if (data && !isLoading) {
    @for (sectionKey of sectionKeys; let i = $index; track i) {
      <div class="section">
        <h3 class="section-title gea-font-heading-24">{{ formatLabel(sectionKey) }}</h3>
        <div class="info-card">
          @for (item of data[sectionKey] | keyvalue: originalOrder; track item.key) {
            <div class="row">
              <span class="label gea-font-heading-16">{{ formatLabel(item.key) }}</span>
              <span class="value gea-font-body-16">{{ formatValue(item.value) }}</span>
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <div class="section">
      <p-skeleton [style]="{ 'margin-bottom': '1.5rem', width: '12rem' }" height="2rem" />
      <div class="info-card">
        <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem" />
        <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem" />
        <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem" />
        <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem" />
        <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem" />
        <p-skeleton [style]="{ 'margin-bottom': '0' }" height="2rem" />
      </div>
    </div>

    <div class="section">
      <p-skeleton [style]="{ 'margin-bottom': '1.5rem', width: '14rem' }" height="2rem" />
      <div class="info-card">
        <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem" />
        <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem" />
        <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem" />
        <p-skeleton [style]="{ 'margin-bottom': '0' }" height="2rem" />
      </div>
    </div>
  }
</div>
